module.exports = __webpack_public_path__ + "static/media/blandine.818ff377.jpg";